import { useEffect, useState } from 'react';

/**
 * Custom hook to handle responsive behavior
 */
export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    // Initial check
    checkIfMobile();

    // Add event listener
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Scroll to top when changing steps
  const scrollToTop = () => {
    // Try to find the closest modal container first
    const modalContainer = document.querySelector('.lp-fixed.lp-inset-0.lp-z\\[9999\\]');
    if (modalContainer) {
      modalContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // If not in modal, scroll the window
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return {
    isMobile,
    scrollToTop
  };
};

export default useResponsive;
